import type { CoverageRule } from '@/shared/types';

// Drops SMB coverage rules that collide on (total_months, total_amount) after
// backend clipping. Keeps the first occurrence in input order — backend always
// returns rules in display order, so this avoids coupling to screening status ids.
export const filterCollidingSmbRules = (rules: CoverageRule[]): CoverageRule[] => {
  const seenKeys = new Set<string>();
  return rules.filter((rule) => {
    if (!rule.pricing) {
      return true;
    }
    const key = `${rule.pricing.total_months}|${rule.pricing.total_amount}`;
    if (seenKeys.has(key)) {
      return false;
    }
    seenKeys.add(key);
    return true;
  });
};
